<template>
  <!-- <div class="h-100"> -->
    <success-create :time-out="ticketDetail.config.timeOutCancel" :ticket-detail="ticketDetail" v-if="ticketDetail.page === page.PAGE_ANTRIAN_SUCCESS"/>
    <list-antrian-dokter :delay-linear="ticketDetail.config" :list-dokter="ticketDetail.listBooking"  v-else-if="ticketDetail.page === page.PAGE_ANTRIAN_LIST_DOKTER" @print="print"/>
    <antrian-mode v-else-if="ticketDetail.page === page.PAGE_MODE_ANTRIAN" :detail="ticketDetail.detailAntrian" :delay-linear="ticketDetail.config" :unit-antrian="ticketDetail.selectUnit"/>
    <error-qr v-else-if="ticketDetail.page === page.PAGE_ANTRIAN_ERROR" :time-out="ticketDetail.config.timeOutCancel" :type-error="ticketDetail.type" />
    <create-queue v-else-if="ticketDetail.page === page.PAGE_ANTRIAN_LIST_SUCCESS" :list-antrian="ticketDetail.listTable" :time-out="ticketDetail.config.timeOutCancel" :type-success="ticketDetail.successTicket" :error-data="ticketDetail.doubleCheckIn" :name-unit="ticketDetail.detailAntrian"></create-queue>
    <show-ticket-with-number-telepon :select-pasien="ticketDetail.selectPasienMultiple" :delayTime="ticketDetail.config" :disabled-button="ticketDetail.disabled" :list-pasien="ticketDetail.listPasien" v-else-if="ticketDetail.page === page.PAGE_DOUBLE_PASIEN" :phone-number="ticketDetail.param"></show-ticket-with-number-telepon>
    <error-counter-mismatch v-else-if="ticketDetail.page === page.PAGE_ANTRIAN_ERROR_COUNTER" :time-out="ticketDetail.config.timeOutCancel" :dokter="ticketDetail.listBooking" :jenis-pembayaran="jenisPembayaran(ticketDetail.listBooking, ticketDetail.tipeCounter)"/>
    <success-create-verified v-else-if="ticketDetail.page === page.PAGE_ANTRIAN_SUCCESS_VERIFIED_PRIBADI" :time-out="ticketDetail.config.timeOutCancel" :nomor-ticket="ticketDetail.listTable.ticket" :dokter="ticketDetail.listBooking"/>
    <error-print-partial v-else-if="ticketDetail.page === page.PAGE_ANTRIAN_ERROR_PRINT_PARTIAL" :time-out="ticketDetail.config"/>
  <!-- </div> -->
</template>

<script>
import SuccessCreate from './SuccessCreate.vue'
import ErrorQr from '@/components/Status/ErrorQr.vue'
import ListAntrianDokter from '@/components/Status/ListAntrianDokter.vue'
import AntrianMode from '@/components/Status/AntrianMode.vue'
import CreateQueue from '@/components/ScanTicket/CreateQueue'
import ShowTicketWithNumberTelepon from '@/views/ShowTicketTeleponDouble.vue'
import ErrorCounterMismatch from '@/components/Status/ErrorCounterMismatch.vue'
import SuccessCreateVerified from '@/components/Status/SuccessCreateVerified.vue'
import ErrorPrintPartial from '@/components/Status/ErrorPrintPartial.vue'

import ENUM_SETUP from '@/enum/typeSetup'
export default {
  data () {
    return {
      page: ENUM_SETUP
    }
  },
  components: {
    SuccessCreate,
    ErrorQr,
    ListAntrianDokter,
    AntrianMode,
    CreateQueue,
    ShowTicketWithNumberTelepon,
    ErrorCounterMismatch,
    SuccessCreateVerified,
    ErrorPrintPartial
  },
  props: {
    ticketDetail: {
      type: Object,
      default: () => {}
    }
  },
  mounted () {
  },
  methods: {
    print (evt) {
      this.$emit('print', evt)
    },
    // mapDokterContract (list) {
    //   return (list || []).map(_item => ({
    //     nama: _item.name,
    //     spesialis: _item.poli,
    //     jamMulai: _item.time,
    //     jenisPembayaran: _item.jenisPenjamin
    //   }))
    // },
    isMismatch (item, tipeCounter) {
      if (item.isVerifiedPasien === false) {
        return item.jenisPenjamin !== tipeCounter
      }
      return item.jenisPenjamin === 'ASURANSI' && tipeCounter === 'PRIBADI'
    },
    mismatchedBooking (list, tipeCounter) {
      const mismatch = (list || []).filter(_item => this.isMismatch(_item, tipeCounter))
      return mismatch.length > 0 ? mismatch : (list || [])
    },
    jenisPembayaran (list, tipeCounter) {
      const mismatch = this.mismatchedBooking(list, tipeCounter)
      return (mismatch[0] && mismatch[0].jenisPenjamin) ?? ''
    }
  }
}
</script>

<style>

</style>
